import { Link } from '@tanstack/react-router'
import { FeatureIcon, type FeatureIconName } from '#bv/components/FeatureIcons'
import { DiscordIcon } from '#bv/components/DiscordIcon'

export function Footer() {
  return (
    <footer
      className="mt-24 border-t"
      style={{ borderColor: 'rgba(0,191,255,0.08)', background: 'rgba(5,5,8,0.98)' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/pulsedigital-logo-mark.png"
                alt="PulseDigital"
                className="h-10 w-auto object-contain"
                style={{ filter: 'drop-shadow(0 0 8px rgba(0, 191, 255,0.35)) drop-shadow(0 0 12px rgba(123, 47, 190,0.25))' }}
              />
              <span
                className="font-display text-2xl tracking-wide"
                style={{
                  background: 'linear-gradient(135deg, #ffffff 0%, #c4d9ff 32%, #00bfff 58%, #93c5fd 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                PulseDigital
              </span>
            </div>
            <p className="text-sm leading-relaxed mb-6" style={{ color: '#5a6d8a' }}>
              The premier digital marketplace for Discord products, streaming services, gaming goods, and premium software. Trusted by 12,000+ customers.
            </p>
            <a
              href="https://discord.gg/tGxhDfRkdE"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-discord rounded-lg px-4 py-2 text-sm"
            >
              <DiscordIcon size={16} white className="shrink-0" />
              Join Discord
            </a>
          </div>

          {/* Shop Links */}
          <div>
            <h4 className="font-display text-base tracking-wide mb-5" style={{ color: '#a5d8ff' }}>SHOP</h4>
            <ul className="space-y-3 text-sm" style={{ color: '#5a6d8a' }}>
              {[
                { label: 'All Products', href: '/shop' },
                { label: 'Cart', href: '/cart' },
                { label: 'Discord Products', href: '/shop?category=discord' },
                { label: 'Streaming Services', href: '/shop?category=streaming' },
                { label: 'Gaming Products', href: '/shop?category=gaming' },
                { label: 'Social Media', href: '/shop?category=social' },
                { label: 'Software & Tools', href: '/shop?category=software' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href as any}
                    className="transition-colors hover:text-[#f0f6ff]"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="font-display text-base tracking-wide mb-5" style={{ color: '#a5d8ff' }}>SUPPORT</h4>
            <ul className="space-y-3 text-sm" style={{ color: '#5a6d8a' }}>
              {[
                { label: 'FAQ', to: '/faq' },
                { label: 'Contact Us', to: '/contact' },
                { label: 'Terms of Service', to: '/terms' },
                { label: 'Refund Policy', to: '/refund' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-[#f0f6ff]">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Trust Badges */}
          <div>
            <h4 className="font-display text-base tracking-wide mb-5" style={{ color: '#a5d8ff' }}>SECURED BY</h4>
            <div className="space-y-3">
              {([
                { icon: 'lock' as FeatureIconName, label: 'SSL Encrypted Checkout', color: '#60a5fa' },
                { icon: 'zap' as FeatureIconName, label: 'Instant Delivery System', color: '#fbbf24' },
                { icon: 'check' as FeatureIconName, label: 'Member feedback on Discord', color: '#34d399' },
                { icon: 'shield' as FeatureIconName, label: 'Vouch-activated warranty', color: '#a78bfa' },
              ]).map((badge) => (
                <div key={badge.label} className="flex items-center gap-3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg" style={{ background: `${badge.color}12`, color: badge.color }}>
                    <FeatureIcon name={badge.icon} size={18} className="text-current" />
                  </span>
                  <span className="text-sm" style={{ color: '#5a6d8a' }}>{badge.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs"
          style={{ borderTop: '1px solid rgba(0,191,255,0.06)', color: '#5a6d8a' }}
        >
          <p>© {new Date().getFullYear()} PulseDigital. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-[#8ecfff] transition-colors">Terms</Link>
            <Link to="/refund" className="hover:text-[#8ecfff] transition-colors">Refunds</Link>
            <Link to="/contact" className="hover:text-[#8ecfff] transition-colors">Contact</Link>
          </div>
          <p>Payments secured by MoneyMotion</p>
        </div>
        <p className="mt-3 text-center text-xs" style={{ color: '#5a6d8a' }}>
          Disclaimer: store and payment processor fees may apply during checkout.
        </p>
        <p
          className="mt-3 text-center text-[10px] leading-normal tabular-nums"
          style={{ color: 'rgba(92, 74, 88, 0.38)' }}
        >
          BV5-iDZ-ebQ-
        </p>
      </div>
    </footer>
  )
}
